import { render, staticRenderFns } from "./user-layout.vue?vue&type=template&id=60f86693&scoped=true"
import script from "./user-layout.vue?vue&type=script&lang=js"
export * from "./user-layout.vue?vue&type=script&lang=js"
import style0 from "./user-layout.vue?vue&type=style&index=0&id=60f86693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f86693",
  null
  
)

export default component.exports